import { render, staticRenderFns } from "./usergroups.vue?vue&type=template&id=8021d4f8&scoped=true"
import script from "./usergroups.vue?vue&type=script&lang=js"
export * from "./usergroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8021d4f8",
  null
  
)

export default component.exports